export const MEMBER_DIRECTORY_PAGE_SIZE = 10;
/** Address State still uses dedicated `stateSearchText` on the search input. */
export const MEMBER_DIRECTORY_STATE_FILTER_NAME = 'State';
export const MEMBER_DIRECTORY_SEARCH_DEBOUNCE_MS = 500;
export const MEMBER_DIRECTORY_FREE_TEXT_SEARCH_DEBOUNCE_MS = 500;
/* State free-text schema from attributeFilters. */
export const MEMBER_DIRECTORY_STATE_FILTER_ID = 'member-directory-state';
export const MEMBER_DIRECTORY_STATE_SEARCH_DEBOUNCE_MS = 500;
